import { FaqUI } from "features";

const FAQ = () => {
  return (
    <>
      <FaqUI />
    </>
  );
};
export { FAQ };
